// An enum with all the types of actions to use in our reducer
export enum UploadActionKind {
    AddColumnsToCreate = "ADD_COLUMNS_TO_CREATE",
    AddColumnsToUpdate = "ADD_COLUMNS_TO_UPDATE",
    SetColumnHeaders = "SET_COLUMN_HEADERS",
    AddDoorsForEnableOrDisable = "ADD_DOORS_FOR_ENABLE_OR_DISABLE",
    AddDoorsForEnableOrDisableWithUnits = "ADD_DOORS_FOR_ENABLE_OR_DISABLE_WITH_UNITS",

    AddErrorMessages = "ADD_ERROR_MESSAGES",
    ClearErrorMessages = "CLEAR_ERROR_MESSAGES",

    IsUploadingFile = "IS_UPLOADING_FILE",
    FileProcessed = "FILE_PROCESSED",

    IsUpdatingData = "IS_UPDATING_DATA",
    DataUpdated = "DATA_UPDATED",

    CloseDoubleCheckChanges = "CLOSE_DOUBLE_CHECK_CHANGES",

    resetAllStates = "RESET_ALL_STATES",
}

// An interface for our actions
export interface UploadAction {
    type: UploadActionKind;
    payload?: any;
}
